/**
 * å¤æ­æ¯å¦HTMLåç´ 
 * @return {Boolean} æ¯å¦HTMLåç´ 
 */
var isElement = function (o) {
    return o instanceof Element || o instanceof HTMLDocument;
};
export default isElement;
//# sourceMappingURL=is-element.js.map